import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import classnames from "classnames";
import moment from "moment";
import _ from "i18n";

import {
  MaximizeIcon,
  ArrowLeftIcon,
  SvgIcon,
  ICONS,
  MinimizeIcon
} from "../Common/Icons";
import { getAccessKeyParam } from "Utils";
import { setPresentationState, setFirstTime, setProgressBar } from "Actions";

import { Button } from "antd";
import Slide from "../Dashboard/Slide";
import ProgressBar from "./ProgressBar";
import ShowComments from "./ShowComments";
import ReactPaginate from "react-paginate";
import Fullscreen from "react-full-screen";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { TiMediaPauseOutline } from "react-icons/ti";
import AnnexeIframe from "../Common/iframes/AnnexeIframe";
import browserHistory from "history/createBrowserHistory";
import { inIframe } from "Utils";
import styles from "./Presentation.local.scss";

class Presentation extends Component {
  presentationIntervalID;
  progressIntervalId;
  timeoutId;

  constructor(props) {
    super(props);

    let slide = window.location.href.split("/")[5];
    let index = 0;
    if (slide) {
      index = Number(slide.split("?")[0] - 1);
    }

    this.state = {
      isFull: false,
      index: index ? index : 0,
      presentationDuration: 20000,
      nbSlides: this.props.data.slides.length,
      showCommentsModal: false,
      selectedComments: [],
      alreadySelected: [],
      speed: 1,
      slideKey: Math.random()

      // firstTime: true,
      // progress: 0
      // timer: setInterval(this.handlerStart, 16000)
    };
    this.onKeyPressed = this.onKeyPressed.bind(this);
  }

  componentWillMount() {
    document.addEventListener("keydown", this.onKeyPressed);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyPressed);
  }

  onKeyPressed(keyboardEvent) {
    const { index, nbSlides } = this.state;
    if (
      (keyboardEvent.key === "ArrowRight" || keyboardEvent.key === "Enter") &&
      index < nbSlides - 1
    ) {
      this.handleSlidePageChange({ selected: index + 1 });
    } else if (keyboardEvent.key === "ArrowLeft" && index > 0) {
      this.handleSlidePageChange({ selected: index - 1 });
    }
  }

  goFull = () => {
    this.setState({ isFull: !this.state.isFull });
  };

  redirectToDashboard = () => {
    let { dispatch } = this.props;
    const { organization } = this.props;
    let year = browserHistory().location.search;
    year && year.includes("year")
      ? dispatch(
          push(
            `/fiche-client/${organization.uen}/${year.replace("?year=", "")}`
          )
        )
      : dispatch(push(`/fiche-client/${organization.uen}`));

    //  this.props.dispatch(push(`/dashboard/${organization.uen}`));
  };

  handleSlidePageChange = ({ selected }) => {
    this.setState({ index: selected, slideKey: Math.random() });
    const { organization, currentNavPage, location, years } = this.props;
    //let searchParams = browserHistory().location.search;
    let year = browserHistory().location.search;
    year && year.includes("year")
      ? (year = year.replace("?year=", "").slice(0, 4))
      : (year = years[0]);
    if (currentNavPage === "PRESENTATION_PAGE") {
      const accessKey = getAccessKeyParam(location);

      window.history.pushState(
        "",
        "",
        `/presentation/${organization.uen}/${selected +
          1}?year=${year}&&access_key=${accessKey}`
      );
    } else {
      window.history.pushState(
        "",
        "",
        `/diaporama/${organization.uen}/${selected + 1}?year=` + year
      );
    }
    this.prepareCommentBySlide(selected);
    this.handlerCloseCommentModal();
  };

  componentDidMount() {
    let { index } = this.state;
    this.prepareCommentBySlide(index);
  }

  prepareCommentBySlide = slideIndex => {
    const {
      data: { slides },
      comments
    } = this.props;
    let commentaires = [];
    comments &&
      // eslint-disable-next-line array-callback-return
      comments.map((item, i) => {
        if (item.slideCode === slides[slideIndex].code) {
          commentaires.push(item);
        }
      });
    this.setState({
      selectedComments: commentaires
    });
  };

  checkIfSlideHasComments = slide => {
    const { comments } = this.props;
    let commentaires = [];
    comments &&
      // eslint-disable-next-line array-callback-return
      comments.map((item, i) => {
        if (item.slideCode === slide.code) {
          commentaires.push(item);
        }
      });
    return commentaires;
  };

  handlerStart = () => {
    const { presentationState, dispatch, firstTime } = this.props;
    let { speed, presentationDuration } = this.state;
    if (presentationState === "play") {
      let slides = this.props.data.slides;
      let nbrSlides = this.props.data.slides.length;
      let { index } = this.state;
      let comments = [];
      let audioComments = [];
      clearTimeout(this.presentationIntervalID);
      this.presentationIntervalID = setInterval(
        this.handlerStart,
        presentationDuration / speed
      );
      if (firstTime) {
        comments = this.checkIfSlideHasComments(slides[index]);
        audioComments = comments.filter(({ type }) => type === "AUDIO");
        dispatch(setFirstTime(false));
      }

      if (index < nbrSlides && comments.length > 0) {
        if (presentationState === "play") {
          clearTimeout(this.timeoutId);
          this.HandlerOpenCommentModal();
          let duree = 0;
          if (audioComments.length > 0) {
            audioComments.map((item, i) => {
              duree += parseFloat(item.content.duration) * 1000;
            });
            if (duree > 0) {
              clearTimeout(this.presentationIntervalID);
              this.presentationIntervalID = setInterval(
                this.handlerStart,
                duree
              );
            }
          }
          let closeDuration = duree > 17000 / speed ? duree : 17000 / speed;
          this.timeoutId = setTimeout(
            this.handlerCloseCommentModal,
            closeDuration
          );
        }
      } else {
        if (index === nbrSlides - 1) {
          this.handlerStopPresentation();
        } else {
          this.handleSlidePageChange({ selected: index + 1 });
        }
      }
    }
  };
  componentDidUpdate(
    prevProps: Readonly<P>,
    prevState: Readonly<S>,
    snapshot: SS
  ): void {
    const { dispatch } = this.props;
    if (prevState.index !== this.state.index) {
      dispatch(setFirstTime(true));
      dispatch(setProgressBar(0));
      this.forceUpdate();
    }
  }

  changeDiaporamaSpeed = speeds => {
    const { dispatch } = this.props;
    this.setState({ speed: speeds });
    dispatch(setProgressBar(0));
    clearInterval(this.presentationIntervalID);
    clearInterval(this.progressIntervalId);
    clearTimeout(this.timeoutId);
    setTimeout(this.handlerStartPresentation, 1000);
  };

  handlerStartPresentation = () => {
    const { dispatch } = this.props;
    let { speed, presentationDuration } = this.state;
    dispatch(setPresentationState("play"));

    let slide = window.location.href.split("/")[5];
    let index = 0;
    if (slide) {
      index = Number(slide.split("?")[0] - 1);
    }

    this.setState({ index: index ? index : 0 });
    this.progressIntervalId = setInterval(this.handlerProgressBar, 1000);
    this.presentationIntervalID = setInterval(
      this.handlerStart,
      presentationDuration / speed
    );
  };

  handlerProgressBar = () => {
    const { presentationState, dispatch, progress } = this.props;
    let { index, speed } = this.state;
    let slides = this.props.data.slides;
    let componentHasComments = this.checkIfSlideHasComments(slides[index]);
    let progressbar =
      componentHasComments.length === 0 ? 1 : componentHasComments.length + 1;

    let audioComments = componentHasComments.filter(
      ({ type }) => type === "AUDIO"
    );
    if (audioComments.length > 0) {
      speed = 1;
    }
    if (progress < 100 && presentationState === "play") {
      if (speed === 1) {
        dispatch(setProgressBar(progress + 5 / progressbar));
        // this.setState({ progress: progress + 5 / progressbar });
      } else if (speed === 2) {
        dispatch(setProgressBar(progress + 10 / progressbar));
        // this.setState({ progress: progress + 10 / progressbar });
      } else if (speed === 4) {
        dispatch(setProgressBar(progress + 20 / progressbar));
        // this.setState({ progress: progress + 20 / progressbar });
      } else if (speed === 1.5) {
        dispatch(setProgressBar(progress + 8 / progressbar));
        // this.setState({ progress: progress + 20 / progressbar });
      }
    }
  };
  handleClick = () => {
    this.forceUpdate();
  };

  handlerStopPresentation = () => {
    const { dispatch, organization } = this.props;

    let slide = window.location.href.split("/")[5];
    let index = 0;
    if (slide) {
      index = Number(slide.split("?")[0] - 1);
    }

    this.setState({
      index: index ? index : 0
    });

    const { currentNavPage, location } = this.props;
    if (currentNavPage === "PRESENTATION_PAGE") {
      const accessKey = getAccessKeyParam(location);

      window.history.pushState(
        "",
        "",
        `/presentation/${organization.uen}/${
          index ? index + 1 : 1
        }?access_key=${accessKey}`
      );
    } else {
      window.history.pushState(
        "",
        "",
        `/diaporama/${organization.uen}/${index ? index + 1 : 1}`
      );
    }

    // dispatch(setProgressBar(0));
    clearInterval(this.presentationIntervalID);
    clearInterval(this.progressIntervalId);
    clearTimeout(this.timeoutId);
    dispatch(setPresentationState("pause"));
  };

  HandlerOpenCommentModal = () => {
    let { showCommentsModal } = this.state;
    if (showCommentsModal) {
      this.handlerCloseCommentModal();
    } else {
      var modal = document.getElementById("myModal");
      modal.style.display = "block";
      this.setState({
        showCommentsModal: true
      });
    }
  };

  handlerCloseCommentModal = () => {
    let modal = document.getElementById("myModal");
    modal.style.display = "none";
    this.setState({
      showCommentsModal: false
    });
  };

  render() {
    const {
      // speed,
      progress,
      presentationState,
      comments,
      data: { slides, extraInfos, period, dashboardOwner },
      currentOrganization
    } = this.props;

    const {
      index,
      nbSlides,
      selectedComments,
      speed,
      slideKey,
      showCommentsModal
    } = this.state;
    let slideComments = [];
    comments &&
      slides &&
      // eslint-disable-next-line array-callback-return
      comments.map((item, i) => {
        if (item.slideId === slides[index].id) {
          slideComments.push(item);
        }
      });

    return (
      <Fullscreen
        enabled={this.state.isFull}
        onChange={isFull => this.setState({ isFull })}
      >
        <div
          className={
            styles.diaporama_slide +
            " " +
            (this.state.isFull ? styles.diaporama_full_slide : null)
          }
          onKeyDown={() => this.onKeyPressed}
          tabIndex="0"
        >
          {!this.props.hideIframe ? <div className={styles.iframe_mask} /> : ""}
          <div
            className={
              styles.diaporama_header +
              " " +
              (this.state.isFull ? styles.diaporama_full_header : null)
            }
          >
            <div className={styles.left_side}>
              <Button
                key="cancel"
                style={{
                  padding: "3px 10px",
                  marginRight: 5,
                  alignItems: "center",
                  color: "#6D7F92",
                  background: "#F8F9FA",
                  border: "1px solid #B2BCC6",
                  boxSizing: "border-box",
                  borderRadius: "5px"
                }}
                onClick={this.redirectToDashboard}
              >
                <ArrowLeftIcon width={12} height={24} />
              </Button>
              <div className={styles.title}>
                Bilan {period} {dashboardOwner && dashboardOwner.name}
              </div>
              <div className={styles.dot} />
              <div className={styles.date}>{moment().format("DD/MM/YYYY")}</div>
            </div>
            <div className={styles.actions}>
              <Button
                key="cancel"
                style={{
                  padding: "5px",
                  height: 32,
                  marginRight: 5,
                  alignItems: "center",
                  color: "#6D7F92",
                  background: "transparent",
                  border: "1px solid #B2BCC6",
                  boxSizing: "border-box",
                  borderRadius: "5px"
                }}
                onClick={this.goFull}
              >
                {this.state.isFull ? (
                  <MinimizeIcon />
                ) : (
                  <MaximizeIcon width={12} height={24} />
                )}
              </Button>
            </div>
          </div>
          {slides[index] ? (
            <Slide
              key={slideKey}
              slide={slides[index]}
              handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
              isPresentation={true}
              isComposition={false}
              isPreparePresentation={false}
              comments={slideComments}
              openCommentModal={this.HandlerOpenCommentModal}
              selectedComponent={this.props.selectedComponent}
              explanations={this.props.indicatorsExplanation}
              indicators={this.props.suggestions}
              lng={this.props.lng}
              extraInfos={extraInfos}
              currentOrganization={currentOrganization}
              inSlideView={true}
            />
          ) : (
            <NotFoundV2 errorPageType={"ERROR_404"} />
          )}
          <div
            className={
              styles.diaporama_footer +
              " " +
              (this.state.isFull ? styles.diaporama_full_footer : null)
            }
          >
            <div
              className={classnames(
                "large-4 medium-5 small-5",
                styles.diaporama_actions
              )}
            >
              {presentationState === "play" ? (
                <Button
                  key="comment"
                  style={{
                    height: 36,
                    width: 130,
                    marginRight: 5,
                    display: "flex",
                    color: "#FFFFFF",
                    margin: "0px 10px",
                    borderRadius: "40px",
                    alignItems: "center",
                    background: "#18A0FB",
                    boxSizing: "border-box",
                    border: "transparent",
                    justifyContent: "space-around",
                    textTransform: "uppercase"
                  }}
                  onClick={() => this.handlerStopPresentation()}
                >
                  <TiMediaPauseOutline />
                  {_("pause")}
                </Button>
              ) : (
                <Button
                  key="comment"
                  style={{
                    height: 36,
                    width: 130,
                    marginRight: 5,
                    display: "flex",
                    color: "#FFFFFF",
                    margin: "0px 10px",
                    borderRadius: "40px",
                    alignItems: "center",
                    background: "#18A0FB",
                    boxSizing: "border-box",
                    border: "transparent",
                    justifyContent: "space-around",
                    textTransform: "uppercase"
                  }}
                  onClick={() => this.handlerStartPresentation()}
                >
                  <SvgIcon icon={ICONS.DIAPORAMA} className={"light-icon"} />
                  {_("play")}
                </Button>
              )}
              <div className={styles.speeds}>
                <div
                  style={speed === 1 ? { color: "#2495E1" } : { color: "" }}
                  className={styles.speed}
                  onClick={() => this.changeDiaporamaSpeed(1)}
                >
                  X1
                </div>
                <div
                  style={speed === 2 ? { color: "#2495E1" } : { color: "" }}
                  className={styles.speed}
                  onClick={() => this.changeDiaporamaSpeed(2)}
                >
                  X2
                </div>
                <div
                  style={speed === 4 ? { color: "#2495E1" } : { color: "" }}
                  className={styles.speed}
                  onClick={() => this.changeDiaporamaSpeed(4)}
                >
                  X4
                </div>
                <div
                  style={speed === 1.5 ? { color: "#2495E1" } : { color: "" }}
                  className={styles.speed}
                  onClick={() => this.changeDiaporamaSpeed(1.5)}
                >
                  X0.5
                </div>
              </div>
              <ProgressBar completed={progress} />
            </div>
            <div className={"large-5 medium-5 small-5"}>
              <ReactPaginate
                previousLabel={_("previous")}
                nextLabel={_("next")}
                breakLabel={<a href="">...</a>}
                breakClassName={""}
                pageCount={nbSlides}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={this.handleSlidePageChange}
                containerClassName={"dark_pagination"}
                subContainerClassName={`pages dark_pagination`}
                activeClassName={"current"}
                pageClassName="page"
                forcePage={index}
              />
            </div>
            <div className={"large-2 medium-2 small-2"}>
              {selectedComments.length > 0 && (
                <Button
                  key="comment"
                  style={{
                    height: 36,
                    width: 190,
                    marginRight: 5,
                    display: "flex",
                    color: "#FFFFFF",
                    margin: "auto 60px auto 0px",
                    borderRadius: "50px",
                    alignItems: "center",
                    background: "rgbA(109, 127, 146, 0.7)",
                    boxSizing: "border-box",
                    border: "transparent",
                    justifyContent: "space-around"
                  }}
                  onClick={() => this.HandlerOpenCommentModal()}
                >
                  {selectedComments.length} {_("comments")}
                  <div className={showCommentsModal ? styles.flip_down : ""}>
                    <SvgIcon
                      icon={ICONS.SimpleArrowUp}
                      className={"light-icon"}
                    />
                  </div>
                </Button>
              )}
            </div>
          </div>
          <div id="myModal" className={styles.modal}>
            {showCommentsModal && (
              <ShowComments
                handlerCloseCommentModal={this.handlerCloseCommentModal}
                comments={selectedComments}
              />
            )}
          </div>
          <AnnexeIframe
            hideIframe={this.props.hideIframe}
            srcIframe={this.props.srcIframe}
            loadingIframe={this.props.loadingIframe}
            onCloseIframe={this.props.onCloseIframe}
            isNotFound={this.props.isNotFound}
          />
        </div>
      </Fullscreen>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  comments: state.preparePresentation.items.comments,
  selectedComponent: state.preparePresentation.selectedComponent,
  presentationState: state.preparePresentation.presentationState,
  organization: state.dashboard.organization,
  speed: state.preparePresentation.speed,
  firstTime: state.preparePresentation.firstTime,
  progress: state.preparePresentation.progress,
  indicatorsExplanation: state.indicatorsExplanation.items,
  suggestions: state.indicators.suggestions.items,
  lng: state.params.lng,
  years: state.dashboard.data.extraInfos.years,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(Presentation);



// WEBPACK FOOTER //
// ./src/components/Presentation/Presentation.js